import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Form,
  Col,
  Row,
  CardSubtitle,
  Alert,
  Container,
  Progress,
  Spinner,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useNavigate } from "react-router-dom";
import Dropzone from "react-dropzone";
import axios from "axios";
import {  BACKEND_URL_DOC, BACKEND_URL_PORTAIL } from "../../../config/const.js";
import { useTranslation } from "react-i18next";
import "./Styles.css";
// 🔓 Rôles "compounding" additifs : ils ne font pas partie de la sélection unique
// (admin / adminClient / preparer) et se cumulent librement avec le rôle principal.
const ADDITIVE_COMPOUNDING_ROLES = ["verificator", "inventory"];

const CreateNewUser = () => {
  const { t } = useTranslation();

  document.title = t("createUserTitle");
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedGroups, setSelectedGroups] = useState([]); // Store the selected listOfGroups
  const [listOfGroup, setListOfGroups] = useState([]); // Store the currently selected listOfGroup
  const [organizations, setOrganization] = useState([]);
  const [originalOrganizations, setOriginalOrganisations] = useState([]);
  const [listRoleOfGroup, setListRoleOfGroup] = useState([]);
  const [newUser, setNewUser] = useState("create");
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [userNameError, setUserNameError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastNameEroor, setLastNameError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [validEmailError, setValidEmailError] = useState(null);
  const [userAddedMessage, setUserAddedMessage] = useState(null);
  const [error, setError] = useState(null);
  const [userNameExistsError, setUserNameExistsError] = useState(null);
  const [emailExistsError, setEmailExistsError] = useState(null);
  const [selectedGroupsError, setSelectedGroupsError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [groupIdSelected, setGroupIdSelected] = useState("");
  const [passwordStrength, setPasswordStrength] = useState({
    value: 0,
    text: "",
    color: "",
  });
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [formData, setFormData] = useState({
    id: "",
    
    username: "",
    lastname: "",
    firstname: "",
    password: "",
    email: "",
    phone: "",
    phone2: "",
    isEnabled: true,
    isAvailable: true,
    has2Fa: false,
    passwordChange: true,
    listOfGroups: listOfGroup,
    signature: selectedFiles,
    listRoleOfGroup: listRoleOfGroup,
    filesNames: selectedFiles ? selectedFiles.name : "", // Attribut supplémentaire pour les fichiers
    language: localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en",
    currentOrg: localStorage.getItem("currentOrg"),
  });
  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(
          `${BACKEND_URL_PORTAIL}api/getGroupNotAffectedPortail/` + null,
          config
        );
        setListOfGroups([...listOfGroup, response[0].groupId]);
        // Assuming response.data is an array of organizations
        const options = response.map((org) => ({
          groupeName: org.groupeName,
          groupId: org.groupId,
          quessRegistre:org.quessRegistre,
          quessControle:org.quessControle,
          quessCompounent:org.quessCompounent
        }));
        setOriginalOrganisations(options);
        setOrganization(options);
        setLoading(false);
        setLoadingPage(false);
      } catch (error) {
        setError("Failed to load organizations");
        setLoading(false);
        setLoadingPage(false);
      }
    };

    fetchOrganization();

    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
 const addGroup = () => {
  let selectedGroup = null;

  if (groupIdSelected === "") {
    selectedGroup = organizations.find(
      (g) => g.groupId === parseInt(organizations[0]?.groupId)
    );
  } else {
    selectedGroup = organizations.find(
      (g) => g.groupId === parseInt(groupIdSelected)
    );
    setGroupIdSelected("");
  }

  if (
    selectedGroup &&
    !selectedGroups.find((g) => g.groupId === selectedGroup.groupId)
  ) {
    // 🎯 rôle compounding par défaut (dernier, hors rôles additifs verificator / inventory)
    const primaryCompounentRoles =
      selectedGroup.quessCompounent?.filter(
        c => !ADDITIVE_COMPOUNDING_ROLES.includes(c.name)
      ) || [];
    const defaultRole = primaryCompounentRoles[primaryCompounentRoles.length - 1];

    /* =====================================================
       1️⃣ Préparer le groupe AVEC checked correct (UI)
    ====================================================== */
    const preparedGroup = {
      ...selectedGroup,
      quessCompounent: selectedGroup.quessCompounent.map(comp => ({
        ...comp,
        checked: defaultRole ? comp.id === defaultRole.id : false
      })),
      quessRegistre: selectedGroup.quessRegistre.map(r => ({
        ...r,
        checked: false
      })),
      quessControle: selectedGroup.quessControle.map(c => ({
        ...c,
        checked: false
      }))
    };

    /* =====================================================
       2️⃣ Ajouter le groupe à l’UI
    ====================================================== */
    setSelectedGroups(prev => [...prev, preparedGroup]);

    /* =====================================================
       3️⃣ Ajouter le rôle par défaut (SOURCE MÉTIER)
    ====================================================== */
    if (defaultRole) {
      setListRoleOfGroup(prev => [
        ...prev,
        {
          groupId: selectedGroup.groupId,
          itemId: defaultRole.id,
        },
      ]);
    }

    /* =====================================================
       4️⃣ FormData + listes
    ====================================================== */
    setFormData(prev => ({
      ...prev,
      listOfGroups: [...prev.listOfGroups, selectedGroup.groupId],
    }));

    setOrganization(organizations.filter(g => g !== selectedGroup));

     setListOfGroups((prev) => [
  ...(prev || []),
  selectedGroup.groupId,
]);
  }
};

  const handleSelectGroup = (e) => {
    setGroupIdSelected(e.target.value);
  };
  console.log(listRoleOfGroup)
/*   const removeGroup = (listOfGroupId) => {
    const selectedGroup = selectedGroups.find(
      (g) => g.groupId === listOfGroupId
    );

    setSelectedGroups(selectedGroups.filter((g) => g.groupId !== listOfGroupId));
    setListRoleOfGroup(prev =>
    prev.filter(role => role.groupId !== listOfGroupId)
  );
    setOrganization([...organizations, selectedGroup]);
  };
 */
  
  const removeGroup = (listOfGroupId) => {

     const selectedGroup = selectedGroups.find(
      (g) => g.groupId === listOfGroupId
    );
  // 1️⃣ state listOfGroup
  setListOfGroups(prev =>
    prev.filter(g => g !== listOfGroupId));

  // 2️⃣ formData.listOfGroups
   setFormData(prev => ({
    ...prev,
    listOfGroups: prev.listOfGroups.filter(
      g => g !== listOfGroupId
    ),
  }));

  // 3️⃣ selectedGroups
  setSelectedGroups(prev =>
    prev.filter(g => g.groupId !== listOfGroupId)
  );

  // 4️⃣ listRoleOfGroup
  setListRoleOfGroup(prev =>
    prev.filter(role => role.groupId !== listOfGroupId)
  );

  setOrganization([...organizations, selectedGroup]);
};
function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );

    // Store only the first file (for single file upload)
    setSelectedFiles(files[0]);
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const navigate = useNavigate();

console.log(selectedGroups);
  const calculatePasswordStrength = (password) => {
    let strength = 0;
    let text = t("veryWeak");
    let color = "dark";

    // Check length
    const isLongEnough = password.length >= 4;

    if (!isLongEnough) {
      // If password is too short
      setPasswordStrength({ value: 0, text: t("veryWeak"), color: "dark" });
      return;
    }
    // Criteria checks
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const criteriaCount = [
      hasUpperCase,
      hasLowerCase,
      hasDigit,
      hasSpecialChar,
    ].filter(Boolean).length;

    switch (criteriaCount) {
      case 4:
        strength = 100;
        text = t("strong");
        color = "success";
        break;
      case 3:
        strength = 75;
        text = t("good");
        color = "info";
        break;
      case 2:
        strength = 50;
        text = t("fair");
        color = "warning";
        break;
      case 1:
        strength = 25;
        text = t("weak");
        color = "danger";
        break;
      default:
        strength = 0;
        text = t("veryWeak");
        color = "light";
    }

    setPasswordStrength({ value: strength, text, color });
  };
  useEffect(() => {
    calculatePasswordStrength(formData.password);
    checkPasswordMatch(formData.password, formData.passwordConfirmation);
  }, [formData.password, formData.passwordConfirmation]);

  const handlePasswordConfirmationChange = (e) => {
    setFormData({ ...formData, passwordConfirmation: e.target.value });
  };
  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setFormData({ ...formData, password });
    calculatePasswordStrength(password);
  };
 
  /* const handleChangeGroupRole = (groupId, roleId) => {
    // Vérification si l'élément existe déjà dans listRoleOfGroup
    const groupRole = listRoleOfGroup.find(
      (el) => el.groupId === groupId && el.itemId === roleId
    );
  
    // Mise à jour de listRoleOfGroup
    if (groupRole) {
      const updatedListRoleOfGroup = listRoleOfGroup.filter(
        (el) => !(el.groupId === groupId && el.itemId === roleId)
      );
      setListRoleOfGroup(updatedListRoleOfGroup);
    } else {
      setListRoleOfGroup([...listRoleOfGroup, { groupId, itemId: roleId }]);
    }
  
      // Mise à jour de selectedGroups
      const updatedGroups = selectedGroups.map((group) => {
    if (group.groupId == groupId) {
      // Vérifie si le roleId appartient à quessCompounent
      const isCompounent = group.quessCompounent.some(c => c.id === roleId);

      return {
        ...group,
        quessRegistre: group.quessRegistre.map((registre) => {
          if (registre.id == roleId) {
            return {
              ...registre,
              checked: !registre.checked, // Inverse le checked
            };
          }
          return registre;
        }),
        quessControle: group.quessControle.map((controle) => {
          if (controle.id == roleId) {
            return {
              ...controle,
              checked: !controle.checked, // Inverse le checked
            };
          }
          return controle;
        }),
        quessCompounent: isCompounent
          ? group.quessCompounent.map((compounent) => ({
              ...compounent,
              checked: compounent.id === roleId // un seul élément coché
            }))
          : group.quessCompounent, // inchangé si ce n’est pas un composant
      };
    }
    return group;
    });

  
    setSelectedGroups(updatedGroups);
  }; */
  
  const handleChangeGroupRole = (groupId, roleId) => {
  // 🔎 Récupérer le groupe courant
  const currentGroup = selectedGroups.find(
    g => g.groupId === groupId
  );

  if (!currentGroup) return;

  // 🔎 Les rôles "verificator" et "inventory" sont additifs : ils ne font pas partie
  // du groupe à sélection unique et se cumulent avec le rôle principal.
  const isAdditiveRole = ADDITIVE_COMPOUNDING_ROLES.includes(
    currentGroup.quessCompounent?.find(c => c.id === roleId)?.name
  );

  // 🔎 IDs des compounding du groupe (hors rôles additifs)
  const compoundingIds =
    currentGroup.quessCompounent
      ?.filter(c => !ADDITIVE_COMPOUNDING_ROLES.includes(c.name))
      .map(c => c.id) || [];

  const isCompounding = compoundingIds.includes(roleId);

  /* =====================================================
     1️⃣ MISE À JOUR DE listRoleOfGroup (SOURCE MÉTIER)
  ====================================================== */
  setListRoleOfGroup(prev => {
    const exists = prev.some(
      el => el.groupId === groupId && el.itemId === roleId
    );

    // 🔁 Toggle normal (registre / controle)
    if (!isCompounding) {
      if (exists) {
        return prev.filter(
          el => !(el.groupId === groupId && el.itemId === roleId)
        );
      }
      return [...prev, { groupId, itemId: roleId }];
    }

    // 🔒 CAS COMPUNDING → UN SEUL AUTORISÉ
    let cleaned = prev.filter(
      el =>
        el.groupId !== groupId ||
        !compoundingIds.includes(el.itemId)
    );

    return [...cleaned, { groupId, itemId: roleId }];
  });

  /* =====================================================
     2️⃣ MISE À JOUR DE selectedGroups (UI)
  ====================================================== */
  const updatedGroups = selectedGroups.map(group => {
    if (group.groupId !== groupId) return group;

    return {
      ...group,

      // ✅ Registres → multi
      quessRegistre: group.quessRegistre.map(registre =>
        registre.id === roleId
          ? { ...registre, checked: !registre.checked }
          : registre
      ),

      // ✅ Controle → multi
      quessControle: group.quessControle.map(controle =>
        controle.id === roleId
          ? { ...controle, checked: !controle.checked }
          : controle
      ),

      // 🔓 Verificator / Inventory → additifs (indépendants du rôle principal)
      // 🔒 Autres compounding (admin/adminClient/preparer) → un seul
      quessCompounent: group.quessCompounent.map(comp => {
        if (isAdditiveRole) {
          return comp.id === roleId ? { ...comp, checked: !comp.checked } : comp;
        }
        if (isCompounding) {
          return ADDITIVE_COMPOUNDING_ROLES.includes(comp.name)
            ? comp
            : { ...comp, checked: comp.id === roleId };
        }
        return comp;
      })
    };
  });

  setSelectedGroups(updatedGroups);
};
  function sanitizeFileName(originalFileName) {
    return originalFileName.replace(/\//g, " "); // Replace all slashes with a blank space
  }
  const checkUserName = () => {
    if (formData.username == "") {
      setUserNameError(true);
      return false;
    } else {
      setUserNameError(null);
      return true;
    }
  };
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic regex for email validation
    return re.test(email);
  };

  const checkPassword = () => {
    if (formData.password == "") {
      setPasswordError(true);
      return false;
    } else {
      setPasswordError(null);
      return true;
    }
  };
  const checkFirstName = () => {
    if (formData.firstname == "") {
      setFirstNameError(true);
      return false;
    } else {
      setFirstNameError(null);
      return true;
    }
  };
  const checkLastName = () => {
    if (formData.lastname == "") {
      setLastNameError(true);
      return false;
    } else {
      setLastNameError(null);
      return true;
    }
  };
  /* const checkPhone = () => {
    if (formData.phone == "") {
      setPhoneError(true);
      return false;
    } else {
      setPhoneError(null);
      return true;
    }
  }; */
  const checkEmail = () => {
    if (formData.email == "") {
      setEmailError(true);
      return false;
    } else {
      setEmailError(null);
      return true;
    }
  };
  const checkValidEmail = () => {
    if (formData.email == "") {
      setValidEmailError(null);
      return true;
    } else if (!validateEmail(formData.email)) {
      setValidEmailError(true);
      return false;
    } else {
      setValidEmailError(null);
      return true;
    }
  };
  const checkUserNameExists = async (username)=>{
    if(username!=""){
      const userExists = await axios.get(
        `${BACKEND_URL_PORTAIL}api/user/check/`+
        username+`/`+null,
        config
      );
        return userExists.exists
    }
    
  }
  const checkEmailExists = async (email)=>{
    const userExists = await axios.get(
      `${BACKEND_URL_PORTAIL}api/user/checkEmail/`+
      email+`/`+null,
      config
    );
      return userExists.exists
  }
  const checkUserNameInDb=async ()=> {
  const  exists= await checkUserNameExists(formData.username)

    if(exists)
    {
      setUserNameExistsError(true)
      return exists
    }
    else {
      setUserNameExistsError(null)
      return exists
    }
      
  }
  const checkSelectedGroups = () => {
    if (selectedGroups.length == 0) {
      setSelectedGroupsError(true);
      return false;
    } else {
      setSelectedGroupsError(null);
      return true;
    }
  };
  const checkEmailInDb=async ()=> {
    const  exists= await checkEmailExists(formData.email)
   
      if(exists)
      {
        setEmailExistsError(true)
        return exists
      }
      else {
        setEmailExistsError(null)
        return exists
      }
        
    }
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const isUserNameValid = checkUserName();
    const isFirstNameValid = checkFirstName();
    const isLastNameValid = checkLastName();
    const isPasswordValid = checkPassword();
    const isEmailValid = checkEmail();
    /* const isPhoneValid = checkPhone(); */
    const isEmailFormatValid = checkValidEmail();
    const isPasswordMatch = passwordMatch === true;
    const userNameExistsInDb=await  checkUserNameInDb()
    const emailExistsInDb= isEmailValid?await  checkEmailInDb():true;
    const groupsNotEmpty = checkSelectedGroups();
    if (
      !isUserNameValid ||
      !isFirstNameValid ||
      !isLastNameValid ||
      !isPasswordValid ||
      !isEmailValid ||
      /* !isPhoneValid || */
      !isEmailFormatValid ||
      !isPasswordMatch ||
      userNameExistsInDb ||
      !groupsNotEmpty ||
      emailExistsInDb
    ) {
      setUserAddedMessage({ text: t("failureAddUser"), type: "error" });
      setTimeout(() => {
        setUserAddedMessage(null);
        setLoading(null);
      }, 2500);
    } else {
      const solutions = JSON.parse(localStorage.getItem("currentSolution")) || [];
      const currentSolution =
        solutions.find((item) => item.id === 2)?.id || null;
      const userData = {
        id: formData.id,
        app:"",
        username: formData.username,
        lastname: formData.lastname,
        firstname: formData.firstname,
        password: formData.password,
        email: formData.email,
        phone: formData.phone,
        phone2: formData.phone2,
        isEnabled: formData.isEnabled,
        isAvailable: formData.isAvailable,
        has2Fa: formData.has2Fa,
        reason: newUser,
        other: formData.other,
        currentSolution: currentSolution,
        passwordChange: formData.passwordChange,
        listOfGroup: formData.listOfGroups.filter((group) => group !== ""),
        listRoleOfGroup: listRoleOfGroup, // Pas besoin de JSON.stringify
        filesNames: selectedFiles ? sanitizeFileName(selectedFiles.name) : "",
        language: formData.language,
        currentOrg: formData.currentOrg,
        other: "",
        signature: formData.signature ? formData.signature : selectedFiles, // Gérer les fichiers si besoin
      };
      const configUpload = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      };
      
      try {
        const response = await axios.post(
          `${BACKEND_URL_PORTAIL}api/saveUser`,
          userData,
          config
        );
        if (selectedFiles && selectedFiles.length > 0) {
         //const uplaodData = new FormData();
         //uplaodData.append("file", selectedFiles);
         let promises = [];
         selectedFiles.forEach((el) => {
          const data = new FormData();
          data.append("File", el);
          data.append("fileName", el.name);
          promises.push(
            axios
              .post(BACKEND_URL_PORTAIL + "api/saveSignFile", data, configUpload)
              .then((res) => {})
          );
         })
        }
        
        setLoading(false);
        if (response.status === 'success') {
          setUserAddedMessage({ text: t("successAddUser"), type: "success" });
         const docsData={
            idUser:response.id,
            listOfGroup: formData.listOfGroups.filter((group) => group !== "")
          }
            await axios.post(
          `${BACKEND_URL_DOC}setUserLimitations`,
          docsData,
          config
        );
          setTimeout(() => {
            setUserAddedMessage(null);
            setLoading(null);
            navigate("/users-management");
          }, 2500);
        } else {
          setUserAddedMessage({ text: t("failureAddUser"), type: "error" });
          setTimeout(() => {
            setUserAddedMessage(null);
            setLoading(null);
          }, 2500);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error saving user:", error);
      }
    }
  };
  const checkPasswordMatch = (password, passwordConfirmation) => {
    setPasswordMatch(password === passwordConfirmation);
  };
  const goBack = () => {
    navigate("/users-management"); // Redirect after successful creation
  };

  const handleRemoveFile = () => {
    // Remove the selected file from the state
    setSelectedFiles(null);
  };
  const handlePhoneInput = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Limit to 10 digits
  
    // Format the input as (XXX) XXX-XXXX
    const formatted = cleaned
      .replace(/^(\d{3})(\d{0,3})(\d{0,4})$/, (_, p1, p2, p3) => {
        let result = `(${p1}`;
        if (p2) result += `) ${p2}`;
        if (p3) result += `-${p3}`;
        return result;
      });
  
    // Update formData with the formatted phone number
    setFormData({ ...formData, phone: formatted });
  };
  const handlePhone2Input = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 10);
    setFormData({ ...formData, phone2: cleaned });
  };
  return (
    <React.Fragment>
      <div className="page-content">
      {loadingPage && <div className="text-center mt-6">
                  <Spinner
                 color="primary"
                 style={{
                   height: '3rem',
                   width: '3rem'
                 }}
               >
                 Loading...
                  </Spinner>
                  <div className="text-center mt-2">
                {t("loading...")}
                </div>
                </div>}
        {!loadingPage && (
        <Container  style={{marginTop:"1%"}} fluid={true}>
           <Card className="card-bordred custom-card">
 <Breadcrumbs title={t("user")} breadcrumbItem={t("createUser")} />
          {loading ? (
            <Alert color="info">{t("loadingSubmission")}</Alert>
          ) : error ? (
            <Alert color="danger">{error}</Alert>
          ) : null}
          <div className=" mb-4">
            <div
              style={{
                margin: "1%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              
            </div>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <Card className="card-bordred">
                    <div className="card-header custom-header">
                    <button
                      className="btn btn-primary"
                      title={t("goBack")}
                      onClick={() => goBack()}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    </div>
                    <CardBody>
                      <Card className="card-bordred">
                        <CardBody className="paperGroupStyle">
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("firstName")}</label>
                            </Col>
                            <Col lg={10}>
                              <input
                                name="firstname"
                                className="form-control"
                                type="text"
                                placeholder={t("firstName")}
                                value={formData.firstname}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    firstname: e.target.value,
                                  })
                                }
                              />
                              {firstNameError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("firstNameRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("lastName")}</label>
                            </Col>
                            <Col lg={10}>
                              
                              <input
                                name="lastname"
                                className="form-control"
                                type="text"
                                placeholder={t("lastName")}
                                value={formData.lastname}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    lastname: e.target.value,
                                  })
                                }
                              />
                              {lastNameEroor && (
                                <code className="text-danger">
                                  {" "}
                                  {t("lastNameRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("username")}</label>
                            </Col>
                            <Col lg={10}>
                              <input
                                name="username"
                                className="form-control"
                                type="text"
                                placeholder={t("username")}
                                value={formData.username}
                              
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    username: e.target.value,
                                  })
                                }
                              />
                              {userNameError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("userNameRequiredMessage")}
                                </code>
                              )}
                              {userNameExistsError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("userNameExistsMessage")}
                                </code>
                              )}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                      <Card className="card-bordred">
                        <CardBody className="paperGroupStyleContact">
                            <Row className="mt-3">
                              <Col lg={2}>
                              <label className="form-label">{t("password")}</label>
                              </Col>
                              <Col lg={9} style={{ position: "relative" }}>
                                
                                <input
                                  name="password"
                                  placeholder={t("password")}
                                  className="form-control"
                                  type={showPassword ? "text" : "password"}
                                  value={formData.password}
                                  onChange={handlePasswordChange}
                                />
                                <span 
                              className="password-toggle" 
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                            >
                              {showPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                                
                                
                              </Col>
                              
                            </Row>
                            <Row className="mt-3">
                            <Col lg={2}></Col>
                            <Col lg={9}>
                            {passwordError && (
                                  <code className="text-danger">
                                    {" "}
                                    {t("passwordRequiredMessage")}
                                  </code>
                                )}</Col>
                            </Row>
                            <Row className="mt-3">
                            <Col lg={2}></Col>
                              <Col lg={passwordMatch?3: 4}>
                              <div
                                className={`progress-label text-${passwordStrength.color} border-${passwordStrength.color} mb-2`}
                              >
                                {passwordStrength.text}
                              </div>
                              <Progress
                                striped
                                color={passwordStrength.color}
                                value={passwordStrength.value}
                                id="strongpassword"
                              />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col lg={2}>
                              <label className="form-label">{t("passwordConfirm")}</label>
                              </Col>
                              <Col lg={9}>
                                <input
                                  name="passwordConfirmation"
                                  placeholder={t("passwordConfirm")}
                                  className="form-control"
                                  type={showPasswordConfirm ? "text" : "password"}
                                  value={formData.passwordConfirmation}
                                  onChange={handlePasswordConfirmationChange}
                                />
                                <span 
                                  className="password-toggle" 
                                  onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                  style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                >
                              {showPasswordConfirm ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                                
                              </Col>
                              <Col lg={passwordMatch?1:0} >
                              { formData.password!=""&&formData.passwordConfirmation!=""&&passwordMatch &&<span class="mdi mdi-checkbox-marked-circle-outline" style={{fontSize:"28px",color:"green"}}></span>}

                              </Col>
                            </Row>
                            <Row className="mt-3">
                            <Col lg={2}></Col>
                            <Col lg={9}>
                            {formData.password!=""&&formData.passwordConfirmation!=""&&!passwordMatch && (
                                  <code className="text-danger">
                                    {" "}
                                    {t("passwordDontMatch")}
                                  </code>
                                )}</Col>
                            </Row>
                            <Row className="mt-3">
                              <Col lg={2}>
                              <label className="form-label">
                                  {t("changePassOnLogin")}
                                </label>
                              </Col>
                              <Col lg={9}>
                    
                              <div className="form-check">
                                <input
                                  name="passwordChange"
                                  
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={formData.passwordChange}
                                  onClick={() =>
                                    setFormData({
                                      ...formData,
                                      passwordChange: !formData.passwordChange,
                                    })
                                  }
                                />
                              </div>
                            </Col>
                            </Row>
                        </CardBody>
                      </Card>
                      <Card className="card-bordred">
                        <CardBody className="paperGroupStyle">
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("email")}</label>
                            </Col>
                            <Col lg={10}>
                              <input
                                name="email"
                                className="form-control"
                                type="email"
                                placeholder={t("email")}
                                value={formData.email}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    email: e.target.value,
                                  })
                                }
                              />
                              {emailError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("emailRequired")}
                                </code>
                              )}
                              {validEmailError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("errorEmail")}
                                </code>
                              )}
                              {emailExistsError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("emailExistsErrorMessage")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("phone")}</label>
                            </Col>
                            <Col lg={10}>
                              <input
                                    name="phone"
                                    className="form-control"
                                    type="text" 
                                    placeholder={"(123) 456-7899"} 
                                    value={formData.phone}
                                    onChange={(e) => handlePhoneInput(e.target.value)}
                                  />
                              {/* {phoneError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("phoneRequired")}
                                </code>
                              )} */}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col lg={2}>
                            <label className="form-label">{t("phone2")}</label>
                            </Col>
                            <Col lg={10}>
                              <input
                                    name="phone2"
                                    className="form-control"
                                    type="text" 
                                    placeholder={t("phone2")} 
                                    value={formData.phone2}
                                    onChange={(e) => handlePhone2Input(e.target.value)}
                                  />
                             
                            </Col>
                          </Row>
                          {/* Signature Upload */}
                        <Row  className="mt-3">
                          <Col lg={6}>
                          <label className="form-label">{t("signature")}</label>
                          </Col>
                          <Col lg={6}>
                                <Form className="dropzone"  style={{cursor:"pointer"}}>
                                  <Dropzone
                                 
                                    onDrop={(acceptedFiles) =>
                                      handleAcceptedFiles(acceptedFiles)
                                    }
                                    accept={{
                                      "image/*": [],
                                    }}
                                    maxFiles={1}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div style={{ textAlign: "center" ,cursor:"pointer"}}>
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="mb-3 ">
                                              <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                            </div>
                                            <h4> {t("uloadFiles")}</h4>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  {selectedFiles && (
                                    <div className="mt-3 text-center">
                                      <img
                                        src={selectedFiles.preview}
                                        alt={selectedFiles.name}
                                        style={{
                                          maxWidth: "100%",
                                          height: "auto",
                                        }}
                                      />
                                      <ul className="list-group mt-3">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                          {selectedFiles.name}
                                          <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleRemoveFile()}
                                          >
                                            {t("delete")}
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </Form>
                          </Col>
                        </Row>
                        </CardBody>
                      </Card>
                      <Card className="card-bordred">
                      <CardBody className="paperGroupStyle">
                      
                      {organizations.length > 0 && (
                        <Row className="mt-3">
                          <Col lg={3}>
                            <div className="form-check form-check-end">
                              {selectedGroups.length === 0 ? (
                                <label className="form-label">
                                  {t("addGroup")}
                                </label>
                              ) : (
                                <label className="form-label">
                                  {t("addAnotherGroup")}
                                </label>
                              )}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <select
                              className="form-select"
                              name="listOfGroup"
                              onChange={(e) => handleSelectGroup(e)}
                            >
                              <option
                                aria-selected="true"
                                role="option"
                                value="0"
                                disabled
                              >
                                {t("selectGroup")}
                              </option>
                              {organizations.map((listOfGroup) => (
                                <option
                                  key={listOfGroup.groupId}
                                  value={listOfGroup.groupId}
                                >
                                  {listOfGroup.groupeName}
                                </option>
                              ))}
                            </select>
                            {selectedGroupsError && (
                            <code className="text-danger">
                              {" "}
                              {t("addGroup")}
                            </code>
                          )}
                          </Col>
                          <Col lg={3}>
                            <div className="form-check text-center">
                              <button
                                className="btn btn-outline-info waves-effect waves-light"
                                style={{ borderRadius: "50%" }}
                                type="button"
                                onClick={() => addGroup()}
                              >
                                <i className="fa fa-plus" />
                              </button>
                            </div>
                          </Col>
                        </Row> 
                      )}

                      {selectedGroups.map((selectedGroup) => (
                                                    <Row className="mt-3 row-form" id={`listOfGroupId-${selectedGroup.groupId}`} key={selectedGroup.groupId}>
                                                      <Col lg={3}>
                                                        <div className="form-check form-check-end">
                                                          <label className="form-label">
                                                            {selectedGroup.groupeName}
                                                          </label>
                                                        </div>
                                                      </Col>
                                                      <Col lg={6}>
                                                      <label className="form-check-label text-succes mt-3 mb-2">
                                                        {selectedGroup.quessRegistre.length>0 &&t('QUESSREGISTRES')}
                                                      </label>
                                                        {/* Affichage de quessRegistre */}
                                                        {selectedGroup.quessRegistre &&
                                                          selectedGroup.quessRegistre.map((registre) => (
                                                            <div className="form-check form-check" key={registre.id}>
                                                              <input
                                                                value={registre.id}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`inlineCheck-registre-${registre.id}`}
                                                                checked={registre.checked}
                                                                onClick={() => handleChangeGroupRole(selectedGroup.groupId, registre.id)}
                                                              />
                                                              <label className="form-label" >
                                                                {t(registre.name)}
                                                              </label>
                                                            </div>
                                                          ))}
                                                          <br />
                                                        <label className="form-check-label text-succes mt-3 mb-2">
                                                          {selectedGroup.quessControle.length>0 &&t('QUESSCONTRÔLE')}
                                                        </label>
                                                        {/* Affichage de quessControle */}
                                                        {selectedGroup.quessControle &&
                                                          selectedGroup.quessControle.map((controle) => (
                                                            <div className="form-check form-check" key={controle.id}>
                                                              <input
                                                                value={controle.id}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`inlineCheck-controle-${controle.id}`}

                                                                checked={controle.checked}
                                                                onClick={() => handleChangeGroupRole(selectedGroup.groupId, controle.id)}
                                                              />
                                                              <label className="form-label" >
                                                                {t(controle.name)}
                                                              </label>
                                                            </div>
                                                          ))}
                                                          <label className="form-check-label text-succes mt-3 mb-2">
                                                            {selectedGroup.quessCompounent.length>0 && t('QUESSCOMPOUNDING')}
                                                          </label>
                                                          {/* Affichage de quessCompounent (hors rôles additifs verificator / inventory — voir plus bas) */}
                                                        {selectedGroup.quessCompounent &&
                                                          selectedGroup.quessCompounent
                                                            .filter((compounent) => !ADDITIVE_COMPOUNDING_ROLES.includes(compounent.name))
                                                            .map((compounent) => (
                                                            <div className="form-check form-check" key={compounent.id}>
                                                              <input
                                                                value={compounent.id}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`inlineCheck-compounent-${compounent.id}`}
                                                                checked={compounent.checked}
                                                                onClick={() => {
                                                                  if (!compounent.checked) {
                                                                    handleChangeGroupRole(selectedGroup.groupId, compounent.id);
                                                                  }
                                                                }}
                                                              />
                                                              <label className="form-label" >
                                                                {t(compounent.name)}
                                                              </label>
                                                            </div>
                                                          ))}
                                                          {/* verificator / inventory : rôles additifs, affichés comme des interrupteurs indépendants */}
                                                        {selectedGroup.quessCompounent &&
                                                          ADDITIVE_COMPOUNDING_ROLES
                                                            .map((additiveName) =>
                                                              selectedGroup.quessCompounent.find((c) => c.name === additiveName)
                                                            )
                                                            .filter(Boolean)
                                                            .map((additiveRole) => (
                                                            <div className="verify-toggle-panel" key={`${additiveRole.name}-${selectedGroup.groupId}`}>
                                                              <div>
                                                                <div className="verify-toggle-label">{t(`${additiveRole.name}Access`)}</div>
                                                                <div className="verify-toggle-help">{t(`${additiveRole.name}Help`)}</div>
                                                              </div>
                                                              <label className="verify-switch">
                                                                <input
                                                                  type="checkbox"
                                                                  checked={additiveRole.checked}
                                                                  onClick={() => handleChangeGroupRole(selectedGroup.groupId, additiveRole.id)}
                                                                />
                                                                <span className="verify-switch-track"></span>
                                                              </label>
                                                            </div>
                                                          ))}
                          </Col>
                          <Col lg={3}>
                            <div className="form-check text-center">
                              <button
                                className="btn btn-outline-danger"
                                style={{ borderRadius: "50%" }}
                                type="button"
                                onClick={() => removeGroup(selectedGroup.groupId)}
                              >
                                <i className="fa fa-minus" />
                              </button>
                            </div>
                          </Col>
                        </Row>
                                                  ))}
                      </CardBody>
                      </Card >
                    
                    </CardBody>
                    </Card >
                </Col>
                
              
                <Col lg={12} className="fixed-bottom-buttons">
                                <Row>
                                  <Col md={3}></Col>
                                    <Col md={5}>
                                   
                                    </Col>
                                    <Col md={4}>
                                    <div className="float-end">
                             
                                        <button
                                            type="submit"
                                            className="ms-1 btn btn-success me-3"
                                           // disabled={isFormIncomplete()}
                                        >
                                            {t("save")}
                                        </button>
                                        <button
                                            type="reset"
                                            className="btn btn-info"
                                            onClick={() => goBack()}
                                        >
                                           {t("cancel")}
                                        </button>
                                    </div>
                                        </Col>
                                  </Row>
                                </Col>
              </Row>
            </Form>
            {showScrollTop && (
  <button
    onClick={scrollToTop}
    style={{
      position: "fixed",
      bottom: "80px",
      right: "30px",
      backgroundColor: "#17a2b8",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      fontSize: "20px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      zIndex: 1000,
      cursor: "pointer",
    }}
    title={t("Back to top")}
  >
    ↑
  </button>
)}

            {userAddedMessage && (
              <div
                style={{
                  position: "fixed",
                  bottom: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 20px",
                  backgroundColor:
                    userAddedMessage.type === "success" ? "green" : "#ff3d60",
                  color: "white",
                  borderRadius: "5px",
                  zIndex: 1000,
                  minWidth: "25%",
                  textAlign: "center",
                  transition: "opacity 0.5s ease-in-out",
                }}
              >
                {userAddedMessage.text}
              </div>
            )}
          </div>
           </Card>
         
          
        </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default CreateNewUser;
